module.exports = __webpack_public_path__ + "img/34f5777.png";